import { useState, useMemo, useEffect } from "react";
import { View, Text } from "react-native";
import DateTimePicker, {
  DateType,
  useDefaultStyles,
} from "react-native-ui-datepicker";
import moment from "moment";
import GLOBAL from "../../helpers/global";
import { Pressable } from "react-native-web-hover";
import P, { ArrowContainer } from "react-tiny-popover";

const today = new Date();

const Calendar = ({ startDate, firstDate, onChange, date, style, accentColor }) => {
  const defaultStyles = useDefaultStyles();
  const [selected, setSelected] = useState(firstDate || today);

  useEffect(() => {
    const currentDate = moment(selected).format("YYYY-MM-DD");
    if (date && date !== currentDate) {
      //Update to sync with parent
      const newDate = moment(date, "YYYY-MM-DD").toDate();
      setSelected(newDate);
    }
  }, [date]);

  const [minDate, maxDate] = useMemo(() => {
    return [
      moment(startDate || "2024-01-01", "YYYY-MM-DD").toDate(),
      moment().add(7, "days").toDate(),
    ];
  }, []);

  const handleDate = ({ date }) => {
    setSelected(date);
    if (onChange) onChange(moment(date).format("YYYY-MM-DD"));
  };

  const viewToday = () => {
    handleDate({ date: today });
  };

  return (
    <View
      style={[
        {
          maxWidth: 350,
          borderWidth: 1,
          borderColor: GLOBAL.style.content.borderColor,
          backgroundColor: GLOBAL.style.content.card,
          padding: 12,
          borderRadius: 8,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
          justifyContent: "center",
          alignItems: "center",
        },
        style,
      ]}
    >
      <View style={{ width: "100%" }}>
        <DateTimePicker
          mode="single"
          date={selected}
          onChange={handleDate}
          styles={{
            ...defaultStyles,
            today: {
              borderColor: GLOBAL.style.dropdown,
              borderWidth: 1,
              borderRadius: 8,
            }, // Add a border to today's date
            selected: {
              backgroundColor: GLOBAL.style.dropdown,
              borderRadius: 8,
            }, // Highlight the selected day
            // selected_label: { color: GLOBAL.style.cta.color }, // Highlight the selected day label
            button_next: {
              borderWidth: 1,
              borderRadius: 6,
              borderColor: GLOBAL.style.dropdown,
              padding: 8,
            },
            button_next_image: {
              tintColor: accentColor || GLOBAL.style.color,
              height: 16,
              width: 16,
            },
            button_prev: {
              borderWidth: 1,
              borderRadius: 6,
              borderColor: GLOBAL.style.dropdown,
              padding: 8,
            },
            button_prev_image: {
              tintColor: accentColor || GLOBAL.style.color,
              height: 16,
              width: 16,
            },
            disabled_label: { opacity: 0.2 },
            day_label: { fontFamily: GLOBAL.fonts.regular },
            outside_label: { opacity: 0.4 },
            month_selector_label: {
              fontFamily: GLOBAL.fonts.bold,
              color: GLOBAL.style.color,
              fontSize: 15,
            },
            year_selector_label: {
              fontFamily: GLOBAL.fonts.bold,
              color: GLOBAL.style.color,
              fontSize: 15,
            },
            month_label: {
              fontFamily: GLOBAL.fonts.regular,
              color: GLOBAL.style.color,
            },
            month: {
              borderColor: GLOBAL.style.dropdown,
              borderWidth: 1,
              borderRadius: 8,
            },
            selected_month: {
              borderColor: GLOBAL.style.dropdown,
              backgroundColor: GLOBAL.style.dropdown,
              borderWidth: 1,
              borderRadius: 8,
            },
            year_label: {
              fontFamily: GLOBAL.fonts.regular,
              color: GLOBAL.style.color,
            },
            year: {
              borderColor: GLOBAL.style.dropdown,
              borderWidth: 1,
              borderRadius: 8,
            },
            selected_year: {
              borderColor: GLOBAL.style.dropdown,
              backgroundColor: GLOBAL.style.dropdown,
              borderWidth: 1,
              borderRadius: 8,
            },
          }}
          minDate={minDate}
          maxDate={maxDate}
          showOutsideDays
          navigationPosition="around"
          // timePicker
        />
      </View>
      <Pressable
        onPress={viewToday}
        style={({ hovered, focused, pressed }) => [
          {
            width: "100%",
            backgroundColor: hovered ? GLOBAL.style.dropdown : "transparent",
            borderWidth: 1,
            borderColor: GLOBAL.style.dropdown,
            height: 40,
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
            marginTop: 8,
          },
        ]}
      >
        <Text
          style={{
            fontSize: 14,
            color: GLOBAL.style.color,
            fontFamily: GLOBAL.fonts.bold,
          }}
        >
          Today
        </Text>
      </Pressable>
    </View>
  );
};

export default Calendar;
